import React, { useEffect, useState, useRef } from 'react';
import Fuse from 'fuse.js';
import PropTypes from 'prop-types';
import { Icon, Menu, MenuItem, Pager } from "@unite-us/app-components";
import ConversationCard from "./../conversationCard/conversationCard";
import InboxTypes from "../../../utils/enums/inboxTypes.enum";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ListConversations(_ref) {
  let {
    conversations,
    rawConversationList,
    onConversationClick,
    activeConversationId,
    currentEmployeeId,
    inboxType,
    onChangeInboxType,
    archiveEnabled,
    pagerSettings
  } = _ref;
  const [conversationList, setConversationList] = useState(conversations);
  const [searchValue, setSearchValue] = useState('');
  const prevActiveConversationIdRef = useRef(activeConversationId); //Save the last activeConversationId

  const fuseOptions = {
    keys: ['attributes.client.name', 'attributes.service.name', 'attributes.participants_attributes.name', 'attributes.participants_attributes.provider.name'],
    includeScore: true,
    threshold: 0.4
  };
  const fuse = new Fuse(rawConversationList, fuseOptions);
  useEffect(() => {
    setConversationList(conversations);
    if (searchValue.length > 2) {
      const results = fuse.search(searchValue.trim().toLowerCase());
      setConversationList(results.map(result => result.item));
    } else if (searchValue.length === 0) {
      setConversationList(conversations);
    }
  }, [searchValue, conversations]);
  useEffect(() => {
    if (prevActiveConversationIdRef.current !== activeConversationId) {
      prevActiveConversationIdRef.current = activeConversationId;
      if (activeConversationId && pagerSettings !== null && pagerSettings !== void 0 && pagerSettings.show) {
        const activeIndex = rawConversationList.findIndex(conv => conv.sid === activeConversationId); //Uses the rawConversationList to look for the active conversation

        if (activeIndex !== -1) {
          const newPage = Math.floor(activeIndex / pagerSettings.pageSize) + 1;
          if (newPage !== pagerSettings.pageNumber) {
            pagerSettings.setPageNumber(newPage);
          }
        }
      }
    }
  }, [activeConversationId]);
  useEffect(() => {
    const totalCount = searchValue.length > 0 ? conversationList.length : pagerSettings.totalItemCount;
    const totalPages = Math.ceil(totalCount / pagerSettings.pageSize);
    if (pagerSettings.pageNumber > totalPages) {
      pagerSettings.setPageNumber(totalPages > 0 ? totalPages : 1);
    }
  }, [searchValue, conversationList, pagerSettings]);
  const onOpenConversation = conversation => {
    setSearchValue(''); // Clear search value when opening a conversation
    onConversationClick(conversation);
  };
  const filteredTotalCount = searchValue.length > 0 ? conversationList.length : pagerSettings.totalItemCount;
  const filteredTotalPages = Math.ceil(filteredTotalCount / pagerSettings.pageSize);
  return /*#__PURE__*/_jsxs("div", {
    className: "h-fit",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex mb-3",
      children: [archiveEnabled ? /*#__PURE__*/_jsx(Menu, {
        className: "inline-block",
        anchorElement: /*#__PURE__*/_jsxs("div", {
          className: "flex items-center mb-2 mr-2 text-lg",
          children: [/*#__PURE__*/_jsx("h2", {
            className: "strong inline-block whitespace-no-wrap",
            children: inboxType
          }), /*#__PURE__*/_jsx(Icon, {
            icon: "ChevronArrow",
            direction: "down",
            className: "fill-current ml-2"
          })]
        }),
        children: [InboxTypes.INBOX, InboxTypes.ARCHIVE].map(inboxTypeOption => {
          return /*#__PURE__*/_jsx(MenuItem, {
            primaryNode: inboxTypeOption,
            onClick: () => onChangeInboxType(inboxTypeOption),
            className: inboxType === inboxTypeOption ? 'border-0 border-l-2 border-current-blue border-solid strong' : 'bg-white'
          });
        })
      }) : /*#__PURE__*/_jsx("div", {
        className: "flex items-center mb-2 mr-2 text-lg",
        children: /*#__PURE__*/_jsx("h2", {
          className: "strong inline-block whitespace-no-wrap",
          children: "Inbox"
        })
      }), /*#__PURE__*/_jsxs("p", {
        className: "ml-auto text-mc-gray relative",
        style: {
          top: '2px'
        },
        children: [/*#__PURE__*/_jsx(Icon, {
          icon: "ExclamationCircle",
          className: "fill-current"
        }), "\xA0", /*#__PURE__*/_jsx("span", {
          className: "relative",
          style: {
            top: '2px',
            fontSize: 12
          },
          children: "New messages can be created from cases and referrals."
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-row items-center justify-around text-sm border border-solid border-gray-300 rounded-md mb-3",
      style: {
        height: '2.25rem'
      },
      children: [/*#__PURE__*/_jsx(Icon, {
        icon: "Search",
        color: "black",
        size: "18"
      }), /*#__PURE__*/_jsx("input", {
        placeholder: "Search for people, clients or organizations",
        className: "w-11/12 h-full outline-none",
        value: searchValue,
        onChange: e => setSearchValue(e.target.value)
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "overflow-y-auto hide-scrollbar block mb-4",
      style: {
        height: 'calc(80vh - 10em)'
      },
      children: conversationList.length !== 0 ? conversationList.map((conversation, key) => /*#__PURE__*/_jsx(ConversationCard, {
        currentEmployeeId: currentEmployeeId,
        conversation: conversation,
        activeConversationId: activeConversationId,
        onClick: () => onOpenConversation(conversation),
        searchValue: searchValue
      }, key)) : /*#__PURE__*/_jsxs("p", {
        className: "ml-auto text-mc-gray relative",
        style: {
          top: '2px'
        },
        children: [/*#__PURE__*/_jsx(Icon, {
          icon: "ExclamationCircle",
          className: "fill-current"
        }), "\xA0", /*#__PURE__*/_jsx("span", {
          className: "relative",
          style: {
            top: '2px'
          },
          children: "No conversations found."
        })]
      })
    }), (pagerSettings === null || pagerSettings === void 0 ? void 0 : pagerSettings.show) && /*#__PURE__*/_jsx(Pager, {
      id: "message-center-pager",
      onNextClick: () => pagerSettings.setPageNumber(pagerSettings.pageNumber + 1),
      onPrevClick: () => pagerSettings.setPageNumber(pagerSettings.pageNumber - 1),
      paging: {
        current_page: pagerSettings.pageNumber,
        next_page: pagerSettings.pageNumber + 1 > filteredTotalPages ? null : pagerSettings.pageNumber + 1,
        prev_page: pagerSettings.pageNumber - 1 === 0 ? null : pagerSettings.pageNumber - 1,
        per: pagerSettings.pageSize,
        total_count: filteredTotalCount,
        total_pages: filteredTotalPages
      }
    })]
  });
}
ListConversations.defaultProps = {
  moreConversationsToBeLoaded: false,
  onConversationClick: null,
  activeConversationId: '',
  currentEmployeeId: '',
  pagerSettings: {
    pageNumber: 1,
    setPageNumber: () => null,
    pageSize: 1,
    setPageSize: () => null,
    totalItemCount: 1,
    totalPageCount: 1,
    showPageSizeSelector: false,
    showLabels: false,
    show: false
  },
  conversations: [{
    sid: '',
    lastmessageDate: function () {
      return new Date();
    },
    unreadMessages: false,
    topic: {
      name: ''
    },
    person: {
      full_name: ''
    },
    participants: [{
      id: '',
      full_name: ''
    }]
  }]
};
ListConversations.propTypes = {
  moreConversationsToBeLoaded: PropTypes.bool,
  onConversationClick: PropTypes.func,
  activeConversationId: PropTypes.string,
  currentEmployeeId: PropTypes.string,
  pagerSettings: PropTypes.shape({
    pageNumber: PropTypes.number,
    setPageNumber: PropTypes.func,
    pageSize: PropTypes.number,
    setPageSize: PropTypes.func,
    totalItemCount: PropTypes.number,
    totalPageCount: PropTypes.number,
    show: PropTypes.bool
  }),
  conversations: PropTypes.arrayOf(PropTypes.shape({
    sid: PropTypes.string,
    lastMessageDate: PropTypes.instanceOf(Date),
    unreadMessages: PropTypes.bool,
    topic: PropTypes.shape({
      name: PropTypes.string
    }),
    person: PropTypes.shape({
      full_name: PropTypes.string
    }),
    participants: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      full_name: PropTypes.string
    }))
  })),
  rawConversationList: PropTypes.arrayOf(PropTypes.shape({
    sid: PropTypes.string,
    lastMessageDate: PropTypes.instanceOf(Date),
    unreadMessages: PropTypes.bool,
    topic: PropTypes.shape({
      name: PropTypes.string
    }),
    person: PropTypes.shape({
      full_name: PropTypes.string
    }),
    participants: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      full_name: PropTypes.string
    }))
  })).isRequired
};
export default ListConversations;
//# sourceMappingURL=listConversations.js.map